import React, { useState, useEffect, useRef } from 'react';
import { userAPI } from '../../../config/user-api';
import { customOrderAPI } from '../../../config/custom-order-api';
import { whatsappAPI } from '../../../config/whatsapp-api';
import { WHATSAPP_SESSION_BLOCKED_MSG } from '../../../constants/whatsappSession';
import './Users.css';
import '../WhatsAppChat/WhatsAppChat.css';
import { AppWindow, Calendar, CalendarCheckIcon, CalendarClock, CheckCircleIcon, Clock, Mail, MessageCircle, Pencil, Phone, Search, Users as UsersIcon, Activity, X, RefreshCw, Coins, Banknote, Ticket, Smartphone, Laptop, Globe, MapPin, Plus, Send } from 'lucide-react';
import { toast } from 'react-toastify';
import { useNavigate, useLocation } from 'react-router-dom';
import { USER_ACTION_TYPE_COLORS, formatAttributeName, getCountryName, getLanguageName } from '../../../constants/constants';
import { ADMIN_PERMISSIONS } from '../../../constants/permissions';
import { helpers } from '../../../utils/helpers';
import MapPickerModal from '../CustomOrders/MapPickerModal';

const normalizeWhatsappPhone = (countryCode = '', phoneNumber = '') => {
    let digits = `${countryCode || ''}${phoneNumber || ''}`.replace(/\D/g, '');
    if (!digits && phoneNumber) digits = String(phoneNumber).replace(/\D/g, '');
    if (digits.length === 8) digits = `974${digits}`;
    return digits;
};

const formatWhatsappChatTime = (value) => {
    if (!value) return '';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return '';
    return date.toLocaleString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    });
};

const UserDetailsShell = ({ isModal, onClose, children }) => {
    if (isModal) return children;
    return (
        <div
            className="users-modal-overlay users-details-modal-overlay"
            onClick={onClose}
        >
            <div
                className="users-details-modal-content"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="users-details-modal-header">
                    <h2>User Details</h2>
                    <button
                        type="button"
                        className="users-details-modal-close"
                        onClick={onClose}
                        aria-label="Close"
                    >
                        <X size={20} />
                    </button>
                </div>
                <div className="users-details-modal-body">
                    {children}
                </div>
            </div>
        </div>
    );
};

const Users = ({ userFilter, isModal = false, adminData }) => {
    const [userStats, setUserStats] = useState({
        totalUsers: 0,
        joinedToday: 0,
        joinedTodayRegistered: 0,
        joinedTodayGuest: 0,
        last7Days: 0,
        last30Days: 0,
        totalNationalities: 0,
        usersWithNationality: 0,
        usersWithoutNationality: 0,
        nationalities: [],
    });
    const [statsLoading, setStatsLoading] = useState(true);
    const [statsError, setStatsError] = useState(null);

    const [showModal, setShowModal] = useState(false);
    const [showDetailsModal, setShowDetailsModal] = useState(false);
    const [searchType, setSearchType] = useState('phone');
    const [searchValue, setSearchValue] = useState('');
    const [searchLoading, setSearchLoading] = useState(false);
    const [searchError, setSearchError] = useState(null);

    const [userDetails, setUserDetails] = useState(null);
    const [orderSummary, setOrderSummary] = useState(null);
    const [addresses, setAddresses] = useState([]);
    const [devices, setDevices] = useState([]);

    // const [showOtpModal, setShowOtpModal] = useState(false);
    // const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [selectedAddress, setSelectedAddress] = useState(null);
    // const [otpValue, setOtpValue] = useState('');
    const [editFormData, setEditFormData] = useState({
        houseNo: '',
        apartment: '',
        zone: '',
        directionToReach: '',
        lat: '',
        long: '',
        isDefault: false,
        receiversName: '',
        receiversPhoneNumber: '',
        receiversWhatsappNumber: '',
        whatsappCountryCode: '+974',
        type: '',
        mapLink: '',
    });
    // const [requestId, setRequestId] = useState(null);

    // const [sendOtpLoading, setSendOtpLoading] = useState(false);
    // const [verifyOtpLoading, setVerifyOtpLoading] = useState(false);
    const [updateAddressLoading, setUpdateAddressLoading] = useState(false);
    const [showMapPicker, setShowMapPicker] = useState(false);
    const [mapPickerResolvedCoords, setMapPickerResolvedCoords] = useState(null);
    const [resolvingShortUrl, setResolvingShortUrl] = useState(false);

    const [showActionLogsModal, setShowActionLogsModal] = useState(false);
    const [actionLogs, setActionLogs] = useState([]);
    const [actionLogsLoading, setActionLogsLoading] = useState(false);
    const [actionLogsPage, setActionLogsPage] = useState(1);
    const [hasMoreLogs, setHasMoreLogs] = useState(true);
    const [loadingMoreLogs, setLoadingMoreLogs] = useState(false);
    const [refreshingLogs, setRefreshingLogs] = useState(false);

    const [showCoinHistoryModal, setShowCoinHistoryModal] = useState(false);
    const [coinHistory, setCoinHistory] = useState([]);
    const [coinHistoryLoading, setCoinHistoryLoading] = useState(false);
    const [coinHistoryPage, setCoinHistoryPage] = useState(1);
    const [hasMoreCoinHistory, setHasMoreCoinHistory] = useState(true);
    const [loadingMoreCoinHistory, setLoadingMoreCoinHistory] = useState(false);
    const [coinFilter, setCoinFilter] = useState('all');
    const [coinBalance, setCoinBalance] = useState(0);
    const [showWalletHistoryModal, setShowWalletHistoryModal] = useState(false);
    const [walletHistory, setWalletHistory] = useState([]);
    const [walletHistoryLoading, setWalletHistoryLoading] = useState(false);
    const [walletHistoryPage, setWalletHistoryPage] = useState(1);
    const [hasMoreWalletHistory, setHasMoreWalletHistory] = useState(true);
    const [loadingMoreWalletHistory, setLoadingMoreWalletHistory] = useState(false);
    const [walletFilter, setWalletFilter] = useState('all');
    const [walletBalance, setWalletBalance] = useState(0);
    const [walletCurrency, setWalletCurrency] = useState('QAR');

    const [showCouponsModal, setShowCouponsModal] = useState(false);
    const [coupons, setCoupons] = useState([]);
    const [couponsLoading, setCouponsLoading] = useState(false);
    const [couponsFilter, setCouponsFilter] = useState('active');

    const canViewWhatsappChat = helpers.hasPermission(adminData, ADMIN_PERMISSIONS.VIEW_WHATSAPP_CHAT);
    const canEditWhatsappChat = helpers.hasPermission(adminData, ADMIN_PERMISSIONS.EDIT_WHATSAPP_CHAT);
    const [whatsappHistory, setWhatsappHistory] = useState([]);
    const [whatsappThreadMeta, setWhatsappThreadMeta] = useState({ lastReplyChatId: '', userPhoneNumber: '', canSendFreeForm: false });
    const [whatsappHistoryLoading, setWhatsappHistoryLoading] = useState(false);
    const [showWhatsappHistoryModal, setShowWhatsappHistoryModal] = useState(false);
    const [showWhatsappNewChatPanel, setShowWhatsappNewChatPanel] = useState(false);
    const [whatsappNewMessage, setWhatsappNewMessage] = useState('');
    const [whatsappComposerText, setWhatsappComposerText] = useState('');
    const [whatsappSending, setWhatsappSending] = useState(false);
    const whatsappMessagesEndRef = useRef(null);

    useEffect(() => {
        if (!isModal) {
            fetchUserStats();
        }
    }, [isModal]);

    useEffect(() => {
        if (userFilter?.userId) {
            setSearchType('id');
            handleSearch('id', userFilter.userId, true);
        } else if (userFilter?.userPhone) {
            setSearchType('phone');
            handleSearch('phone', userFilter.userPhone, true);
            if (!isModal) {
                navigate('/dashboard', { replace: true, state: { page: 'users' } });
            }
        }
    }, [userFilter, isModal]);


    const fetchUserStats = async () => {
        try {
            setStatsLoading(true);
            setStatsError(null);
            const response = await userAPI.getTotalUserStats();

            if (response.success && response.data) {
                const nationalities = Array.isArray(response.data.nationalities)
                    ? response.data.nationalities
                    : [];
                setUserStats({
                    totalUsers: response.data.total || 0,
                    joinedToday: response.data.today || 0,
                    joinedTodayRegistered: response.data.todayRegistered || 0,
                    joinedTodayGuest: response.data.todayGuest || 0,
                    last7Days: response.data.last7Days || 0,
                    last30Days: response.data.last30Days || 0,
                    totalNationalities: response.data.totalNationalities || nationalities.length,
                    usersWithNationality: response.data.usersWithNationality || 0,
                    usersWithoutNationality: response.data.usersWithoutNationality || 0,
                    nationalities,
                });
            } else {
                setStatsError(response.msg || 'Failed to fetch user stats');
            }
        } catch (error) {
            console.error('Error fetching user stats:', error);
            setStatsError('Error fetching user stats');
        } finally {
            setStatsLoading(false);
        }
    };

    const fetchWhatsappChatHistory = async (user = userDetails) => {
        if (!canViewWhatsappChat || !user) return;
        const phone = normalizeWhatsappPhone(user.countryCode, user.phoneNumber);
        if (!phone) {
            setWhatsappHistory([]);
            setWhatsappThreadMeta({ lastReplyChatId: '', userPhoneNumber: '', canSendFreeForm: false });
            return;
        }

        try {
            setWhatsappHistoryLoading(true);
            const response = await whatsappAPI.fetchThread(phone);
            if (response.success) {
                setWhatsappHistory(response.data?.messages || []);
                setWhatsappThreadMeta({
                    lastReplyChatId: response.data?.lastReplyChatId || '',
                    userPhoneNumber: response.data?.userPhoneNumber || phone,
                    canSendFreeForm: response.data?.canSendFreeForm === true,
                });
            } else {
                setWhatsappHistory([]);
                setWhatsappThreadMeta({ lastReplyChatId: '', userPhoneNumber: phone });
            }
        } catch (error) {
            console.error('Error loading WhatsApp chat history:', error);
            setWhatsappHistory([]);
        } finally {
            setWhatsappHistoryLoading(false);
        }
    };

    const handleViewWhatsappChatHistory = async () => {
        if (!canViewWhatsappChat || !userDetails) return;
        setShowWhatsappHistoryModal(true);
        setWhatsappComposerText('');
        await fetchWhatsappChatHistory(userDetails);
    };

    const handleWhatsappHistoryModalClose = () => {
        setShowWhatsappHistoryModal(false);
        setWhatsappComposerText('');
    };

    const getUserDisplayName = (user = userDetails) => {
        if (!user) return 'user';
        return user.name || `${user.firstName || ''} ${user.lastName || ''}`.trim() || 'user';
    };

    useEffect(() => {
        if (showWhatsappHistoryModal) {
            whatsappMessagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
        }
    }, [whatsappHistory.length, showWhatsappHistoryModal]);

    const handleSendFromChatHistory = async (e) => {
        e.preventDefault();
        if (!canEditWhatsappChat || !userDetails || whatsappSending) return;

        const phone = normalizeWhatsappPhone(userDetails.countryCode, userDetails.phoneNumber);
        const message = whatsappComposerText.trim();
        if (!phone) {
            toast.error('User phone number is missing');
            return;
        }
        if (!message) {
            toast.error('Enter a message');
            return;
        }
        if (whatsappThreadMeta.canSendFreeForm === false) {
            toast.error(WHATSAPP_SESSION_BLOCKED_MSG);
            return;
        }

        try {
            setWhatsappSending(true);
            const response = await whatsappAPI.sendChatMessage({
                phoneNumber: phone,
                message,
                chatId: whatsappThreadMeta.lastReplyChatId || '',
                userName: getUserDisplayName(userDetails),
            });

            if (response.success) {
                setWhatsappComposerText('');
                await fetchWhatsappChatHistory(userDetails);
            } else {
                toast.error(response.msg || 'Failed to send WhatsApp message');
            }
        } catch (error) {
            console.error('Error sending WhatsApp message:', error);
            toast.error('Failed to send WhatsApp message');
        } finally {
            setWhatsappSending(false);
        }
    };

    const handleSendUserWhatsappMessage = async (e) => {
        e.preventDefault();
        if (!canEditWhatsappChat || !userDetails) return;

        const phone = normalizeWhatsappPhone(userDetails.countryCode, userDetails.phoneNumber);
        const message = whatsappNewMessage.trim();
        if (!phone) {
            toast.error('User phone number is missing');
            return;
        }
        if (!message) {
            toast.error('Enter a message');
            return;
        }

        try {
            setWhatsappSending(true);
            const response = await whatsappAPI.sendChatMessage({
                phoneNumber: phone,
                message,
                userName: getUserDisplayName(userDetails),
            });

            if (response.success) {
                toast.success('WhatsApp message sent');
                setWhatsappNewMessage('');
                setShowWhatsappNewChatPanel(false);
                setShowWhatsappHistoryModal(true);
                await fetchWhatsappChatHistory(userDetails);
            } else {
                toast.error(response.msg || 'Failed to send WhatsApp message');
            }
        } catch (error) {
            console.error('Error sending WhatsApp message:', error);
            toast.error('Failed to send WhatsApp message');
        } finally {
            setWhatsappSending(false);
        }
    };

    const navigate = useNavigate();
    const handleViewOrderHistory = () => {
        const userName = userDetails.name || `${userDetails.firstName || ''} ${userDetails.lastName || ''}`.trim();
        navigate('/dashboard', {
            state: {
                page: 'orders',
                userId: userDetails._id,
                userName: userName
            }
        });
    };

    const handleSearch = async (type = searchType, value = searchValue?.trim(), auto = false) => {
        if (!auto) {
            if (type === 'email' && !value) {
                toast.error('Please enter an email address');
                return;
            }

            if (type === 'phone' && !value) {
                toast.error('Please enter a phone number');
                return;
            }

            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (type === 'email' && !emailRegex.test(value)) {
                toast.error('Please enter a valid email address');
                return;
            }

            const phoneRegex = /^[0-9]{8}$/;
            if (type === 'phone' && !phoneRegex.test(value)) {
                toast.error('Please enter a valid 8-digit phone number');
                return;
            }

            if (type === 'id' && !value) {
                toast.error('User ID is missing');
                return;
            }
        }

        try {
            setSearchLoading(true);
            setSearchError(null);
            if (!isModal) {
                setShowDetailsModal(true);
            }

            const response = await userAPI.getUserDetails(type, value);

            if (response.success && response.data) {
                setUserDetails(response.data.userDetails);
                setOrderSummary(response.data.orderSummary);
                setAddresses(response.data.addresses || []);
                setDevices(response.data.devices || []);
                setCoinBalance(response.data.userDetails?.coinBalance || 0);
                setWalletBalance(response.data.userDetails?.walletBalance ?? response.data.userDetails?.wallet?.balance ?? 0);
                setWalletCurrency(response.data.userDetails?.wallet?.currency || 'QAR');
                setWhatsappHistory([]);

                if (!auto) {
                    setShowModal(false);
                    setSearchValue('');
                }
                if (!isModal) {
                    setShowDetailsModal(true);
                }
            } else {
                setSearchError(response.msg || 'User not found');
                toast.error(response.msg || 'User not found');
            }
        } catch (error) {
            setSearchError('Failed to fetch user details');
            toast.error('Failed to fetch user details');
            console.error('Error searching user:', error);
        } finally {
            setSearchLoading(false);
        }
    };

    const handleModalClose = () => {
        setShowModal(false);
        setSearchValue('');
    };

    const handleDetailsModalClose = () => {
        setShowDetailsModal(false);
        setUserDetails(null);
        setOrderSummary(null);
        setAddresses([]);
        setDevices([]);
        setSearchError(null);
    };

    const handleEditClick = (address) => {
        setSelectedAddress(address);
        const mapLink = (address.lat && address.long) ? `${address.lat},${address.long}` : '';
        const coords = mapLink ? { lat: parseFloat(address.lat), lng: parseFloat(address.long) } : null;
        setMapPickerResolvedCoords(coords);

        // Parse receiversWhatsappNumber to separate country code from raw phone number
        let whatsappCode = '+974';
        let whatsappNum = address.receiversWhatsappNumber || '';
        if (whatsappNum.startsWith('+')) {
            const match = whatsappNum.match(/^(\+\d{1,4})(.*)$/);
            if (match) {
                whatsappCode = match[1];
                whatsappNum = match[2];
            }
        } else if (whatsappNum.length > 0 && !whatsappNum.startsWith('974')) {
            // Default check, if it starts with standard Qatar digits without country code, it remains.
        }

        setEditFormData({
            houseNo: address.houseNo || '',
            apartment: address.apartment || '',
            zone: address.zone || '',
            directionToReach: address.directionToReach || '',
            lat: address.lat || '',
            long: address.long || '',
            isDefault: address.isDefault || false,
            receiversName: address.receiversName || '',
            receiversPhoneNumber: (address.receiversPhoneNumber || '').replace(/^\+?974/, ''),
            receiversWhatsappNumber: whatsappNum,
            whatsappCountryCode: whatsappCode,
            type: address.type || '',
            mapLink: '', // Clear coordinates from input field
        });
        setShowEditModal(true);
    };

    /* ---- OTP flow commented out ----
    const handleOtpModalClose = () => {
        setShowOtpModal(false);
        setSelectedAddress(null);
        setOtpValue('');
    };
    ---- end OTP flow ---- */

    const handleEditModalClose = () => {
        setShowEditModal(false);
        setSelectedAddress(null);
        setMapPickerResolvedCoords(null);
        setEditFormData({
            houseNo: '',
            apartment: '',
            zone: '',
            directionToReach: '',
            lat: '',
            long: '',
            isDefault: false,
            receiversName: '',
            receiversPhoneNumber: '',
            receiversWhatsappNumber: '',
            whatsappCountryCode: '+974',
            type: '',
            mapLink: '',
        });
    };

    const handleEditFormChange = (field, value) => {
        setEditFormData(prev => ({
            ...prev,
            [field]: value
        }));
    };

    /* ---- OTP confirm flow commented out ----
    const handleConfirmEdit = async () => {
        try {
            setSendOtpLoading(true);
            const response = await userAPI.generateAddressEditOtp(
                userDetails._id,
                selectedAddress._id
            );
            if (response.success) {
                setRequestId(response.data.requestId);
                setShowConfirmModal(false);
                setShowOtpModal(true);
                toast.success('OTP sent successfully');
            } else {
                toast.error(response.msg || 'Failed to send OTP');
            }
        } catch (error) {
            toast.error('Failed to send OTP');
            console.error('Error sending OTP:', error);
        } finally {
            setSendOtpLoading(false);
        }
    };
    ---- end OTP confirm flow ---- */

    const getInitialsFromUser = (user) => {
        const fullName = user?.name || `${user?.firstName || ""} ${user?.lastName || ""}`.trim();
        if (!fullName) return "?";
        const words = fullName.split(" ");
        if (words.length === 1) {
            return words[0][0]?.toUpperCase();
        }
        return (words[0][0] + words[words.length - 1][0]).toUpperCase();
    };

    /* ---- OTP submit flow commented out ----
    const handleOtpSubmit = async () => {
        if (!otpValue.trim()) {
            toast.error("OTP is required");
            return;
        }
        if (!/^\d{4}$/.test(otpValue)) {
            toast.error("OTP must be a 4-digit number");
            return;
        }
        try {
            setVerifyOtpLoading(true);
            const response = await userAPI.verifyAddressEditOtp(requestId, otpValue);
            if (response.success) {
                setShowOtpModal(false);
                setOtpValue('');
                setEditFormData({
                    houseNo: selectedAddress.houseNo || '',
                    apartment: selectedAddress.apartment || '',
                    zone: selectedAddress.zone || '',
                    directionToReach: selectedAddress.directionToReach || '',
                    lat: selectedAddress.lat || '',
                    long: selectedAddress.long || '',
                    isDefault: selectedAddress.isDefault || false,
                    receiversName: selectedAddress.receiversName || '',
                    receiversPhoneNumber: selectedAddress.receiversPhoneNumber || '',
                    receiversWhatsappNumber: selectedAddress.receiversWhatsappNumber || '',
                    type: selectedAddress.type || '',
                });
                setShowEditModal(true);
                toast.success('OTP verified successfully');
            } else {
                toast.error(response.msg || 'Invalid OTP');
            }
        } catch (error) {
            toast.error('Failed to verify OTP');
            console.error('Error verifying OTP:', error);
        } finally {
            setVerifyOtpLoading(false);
        }
    };
    ---- end OTP submit flow ---- */

    // Coordinate extraction helper (same logic as CustomOrderModals)
    const extractCoordinatesFromUrl = (url) => {
        if (!url) return null;
        const cleanUrl = url.trim();
        const coordMatch = cleanUrl.match(/^(-?[\d\.]+)\s*,\s*(-?[\d\.]+)$/);
        if (coordMatch) return { lat: parseFloat(coordMatch[1]), lng: parseFloat(coordMatch[2]) };
        const dMatch = cleanUrl.match(/!3d(-?[\d\.]+)!4d(-?[\d\.]+)/);
        if (dMatch) return { lat: parseFloat(dMatch[1]), lng: parseFloat(dMatch[2]) };
        const atMatch = cleanUrl.match(/@(-?[\d\.]+),(-?[\d\.]+)/);
        if (atMatch) return { lat: parseFloat(atMatch[1]), lng: parseFloat(atMatch[2]) };
        const qMatch = cleanUrl.match(/[?&]q=(-?[\d\.]+),(-?[\d\.]+)/);
        if (qMatch) return { lat: parseFloat(qMatch[1]), lng: parseFloat(qMatch[2]) };
        return null;
    };

    const handleMapLinkChange = async (e) => {
        const val = e.target.value;
        handleEditFormChange('mapLink', val);
        setMapPickerResolvedCoords(null);

        if (!val || !val.trim()) {
            handleEditFormChange('lat', '');
            handleEditFormChange('long', '');
            return;
        }
        const cleanUrl = val.trim();
        const coords = extractCoordinatesFromUrl(cleanUrl);
        if (coords) {
            setMapPickerResolvedCoords(coords);
            handleEditFormChange('lat', String(coords.lat));
            handleEditFormChange('long', String(coords.lng));
            return;
        }
        const isShortUrl = cleanUrl.includes("maps.app.goo.gl") || cleanUrl.includes("goo.gl");
        if (isShortUrl) {
            try {
                setResolvingShortUrl(true);
                const response = await customOrderAPI.extractCoordinates(cleanUrl);
                if (response.success && response.coordinates) {
                    setMapPickerResolvedCoords(response.coordinates);
                    handleEditFormChange('lat', String(response.coordinates.lat));
                    handleEditFormChange('long', String(response.coordinates.lng));
                }
            } catch (err) {
                console.error('Short URL resolution failed:', err);
            } finally {
                setResolvingShortUrl(false);
            }
        }
    };

    const handleMapPickerConfirm = (lat, lng) => {
        if (lat !== undefined && lng !== undefined) {
            setMapPickerResolvedCoords({ lat, lng });
            handleEditFormChange('lat', String(lat));
            handleEditFormChange('long', String(lng));
            handleEditFormChange('mapLink', ''); // No need to show coordinates in input field
        }
        setShowMapPicker(false);
    };

    const getMapLinkCoordStatus = () => {
        if (resolvingShortUrl) return { info: true, message: "Resolving coordinates..." };
        if (mapPickerResolvedCoords) return { success: true, lat: mapPickerResolvedCoords.lat, lng: mapPickerResolvedCoords.lng };
        if (!editFormData.mapLink || !editFormData.mapLink.trim()) return null;
        const coords = extractCoordinatesFromUrl(editFormData.mapLink.trim());
        if (coords) return { success: true, lat: coords.lat, lng: coords.lng };
        return { warning: true, message: "Cannot parse coordinates from this link. Please pick location on map." };
    };

    const handleEditSubmit = async () => {
        // Validation Checks
        if (!editFormData.houseNo || !editFormData.houseNo.trim()) {
            toast.error('House/Building number is required');
            return;
        }
        if (!editFormData.apartment || !editFormData.apartment.trim()) {
            toast.error('Street / Apartment name is required');
            return;
        }
        if (!editFormData.zone || !editFormData.zone.trim()) {
            toast.error('Zone number is required');
            return;
        }

        const coords = mapPickerResolvedCoords || (editFormData.mapLink ? extractCoordinatesFromUrl(editFormData.mapLink) : null);
        if (!coords) {
            toast.error('Please enter a valid Google Maps link or click Pick Location');
            return;
        }

        const phone = editFormData.receiversPhoneNumber ? editFormData.receiversPhoneNumber.trim() : '';
        if (phone && !/^\d{8}$/.test(phone)) {
            toast.error('Receiver phone number must be exactly 8 digits');
            return;
        }

        const whatsapp = editFormData.receiversWhatsappNumber ? editFormData.receiversWhatsappNumber.trim() : '';
        if (whatsapp) {
            const countryCode = editFormData.whatsappCountryCode ? editFormData.whatsappCountryCode.trim() : '';
            if (!countryCode.startsWith('+')) {
                toast.error('WhatsApp country code must start with +');
                return;
            }

            if (countryCode === '+91') {
                if (!/^\d{10}$/.test(whatsapp)) {
                    toast.error('WhatsApp number must be exactly 10 digits');
                    return;
                }
            } else if (countryCode === '+974') {
                if (!/^\d{8}$/.test(whatsapp)) {
                    toast.error('WhatsApp number must be exactly 8 digits');
                    return;
                }
            } else {
                if (!/^\d{7,15}$/.test(whatsapp)) {
                    toast.error('WhatsApp number must be between 7 and 15 digits');
                    return;
                }
            }
        }

        try {
            setUpdateAddressLoading(true);

            const submitData = {
                ...editFormData,
                lat: String(coords.lat),
                long: String(coords.lng),
                receiversPhoneNumber: phone,
                receiversWhatsappNumber: whatsapp,
                whatsappCountryCode: whatsapp ? editFormData.whatsappCountryCode.trim() : '',
            };
            delete submitData.mapLink;

            const response = await userAPI.updateUserAddress('direct', selectedAddress._id, userDetails._id, submitData);

            if (response.success) {
                toast.success('Address updated successfully');
                handleEditModalClose();
                const refreshResponse = await userAPI.getUserDetails(
                    'id',
                    userDetails._id
                );
                if (refreshResponse.success) {
                    setAddresses(refreshResponse.data.addresses || []);
                }
            } else {
                toast.error(response.msg || 'Failed to update address');
            }
        } catch (error) {
            toast.error('Failed to update address');
            console.error('Error updating address:', error);
        } finally {
            setUpdateAddressLoading(false);
        }
    };

    const openInMaps = (lat, long) => {
        if (!lat || !long) return;
        const url = `https://www.google.com/maps?q=${lat},${long}`;
        window.open(url, "_blank");
    };

    const copyToClipboard = (text) => {
        if (!text) return;
        navigator.clipboard.writeText(text);
        toast.success("Device ID copied to clipboard!");
    };

    const handleViewActionLogs = async () => {
        try {
            setActionLogsLoading(true);
            setActionLogsPage(1);
            const response = await userAPI.getUserActionLogs(userDetails._id, 1, 30);

            if (response.success && response.data) {
                setActionLogs(response.data.logs || []);
                setHasMoreLogs(response.data.hasMore || false);
                setShowActionLogsModal(true);
            } else {
                toast.error(response.msg || 'Failed to fetch action logs');
            }
        } catch (error) {
            toast.error('Failed to fetch action logs');
            console.error('Error fetching action logs:', error);
        } finally {
            setActionLogsLoading(false);
        }
    };

    const getTimelineDotColorByType = (type) => {
        return USER_ACTION_TYPE_COLORS[type] || 'grey';
    };

    const handleLoadMoreLogs = async () => {
        try {
            setLoadingMoreLogs(true);
            const nextPage = actionLogsPage + 1;
            const response = await userAPI.getUserActionLogs(userDetails._id, nextPage, 30);

            if (response.success && response.data) {
                setActionLogs(prev => [...prev, ...(response.data.logs || [])]);
                setHasMoreLogs(response.data.hasMore || false);
                setActionLogsPage(nextPage);
            }
        } catch (error) {
            toast.error('Failed to load more logs');
            console.error('Error loading more logs:', error);
        } finally {
            setLoadingMoreLogs(false);
        }
    };

    const handleActionLogsModalClose = () => {
        setShowActionLogsModal(false);
        setActionLogs([]);
        setActionLogsPage(1);
        setHasMoreLogs(true);
    };

    const handleRefreshLogs = async () => {
        try {
            setRefreshingLogs(true);
            setActionLogsPage(1);
            const response = await userAPI.getUserActionLogs(userDetails._id, 1, 30);

            if (response.success && response.data) {
                setActionLogs(response.data.logs || []);
                setHasMoreLogs(response.data.hasMore || false);
            } else {
                toast.error(response.msg || 'Failed to refresh action logs');
            }
        } catch (error) {
            toast.error('Failed to refresh action logs');
            console.error('Error refreshing action logs:', error);
        } finally {
            setRefreshingLogs(false);
        }
    };

    // Coin History Functions
    const handleViewCoinHistory = async (filter = 'all') => {
        try {
            setCoinHistoryLoading(true);
            setCoinHistoryPage(1);
            setCoinFilter(filter);
            const response = await userAPI.getUserCoinHistory(userDetails._id, 1, 20, filter);

            if (response.success && response.data) {
                setCoinHistory(response.data.transactions || []);
                setHasMoreCoinHistory(response.data.pagination?.hasNext || false);
                setCoinBalance(response.data.mainBalance || 0);
                setShowCoinHistoryModal(true);
            } else {
                toast.error(response.msg || 'Failed to fetch coin history');
            }
        } catch (error) {
            toast.error('Failed to fetch coin history');
            console.error('Error fetching coin history:', error);
        } finally {
            setCoinHistoryLoading(false);
        }
    };

    const handleLoadMoreCoinHistory = async () => {
        try {
            setLoadingMoreCoinHistory(true);
            const nextPage = coinHistoryPage + 1;
            const response = await userAPI.getUserCoinHistory(userDetails._id, nextPage, 20, coinFilter);

            if (response.success && response.data) {
                setCoinHistory(prev => [...prev, ...(response.data.transactions || [])]);
                setHasMoreCoinHistory(response.data.pagination?.hasNext || false);
                setCoinHistoryPage(nextPage);
            }
        } catch (error) {
            toast.error('Failed to load more coin history');
            console.error('Error loading more coin history:', error);
        } finally {
            setLoadingMoreCoinHistory(false);
        }
    };

    const handleCoinHistoryModalClose = () => {
        setShowCoinHistoryModal(false);
        setCoinHistory([]);
        setCoinHistoryPage(1);
        setHasMoreCoinHistory(true);
        setCoinFilter('all');
    };

    const handleCoinFilterChange = async (filter) => {
        if (filter === coinFilter) return;
        setCoinFilter(filter);
        setCoinHistoryPage(1);

        try {
            setCoinHistoryLoading(true);
            const response = await userAPI.getUserCoinHistory(userDetails._id, 1, 20, filter);

            if (response.success && response.data) {
                setCoinHistory(response.data.transactions || []);
                setHasMoreCoinHistory(response.data.pagination?.hasNext || false);
            }
        } catch (error) {
            toast.error('Failed to filter coin history');
            console.error('Error filtering coin history:', error);
        } finally {
            setCoinHistoryLoading(false);
        }
    };

    const formatWalletBalance = (balance, currency = 'QAR') => {
        const value = Number(balance) || 0;
        return `${currency} ${value.toFixed(2)}`;
    };

    const handleViewWalletHistory = async (filter = 'all') => {
        try {
            setWalletHistoryLoading(true);
            setWalletHistoryPage(1);
            setWalletFilter(filter);
            const response = await userAPI.getUserWalletHistory(userDetails._id, 1, 20, filter);

            if (response.success && response.data) {
                setWalletHistory(response.data.transactions || []);
                setHasMoreWalletHistory(response.data.pagination?.hasNext || false);
                setWalletBalance(response.data.mainBalance ?? 0);
                setWalletCurrency(response.data.currency || 'QAR');
                setShowWalletHistoryModal(true);
            } else {
                toast.error(response.msg || 'Failed to fetch wallet history');
            }
        } catch (error) {
            toast.error('Failed to fetch wallet history');
            console.error('Error fetching wallet history:', error);
        } finally {
            setWalletHistoryLoading(false);
        }
    };

    const handleLoadMoreWalletHistory = async () => {
        try {
            setLoadingMoreWalletHistory(true);
            const nextPage = walletHistoryPage + 1;
            const response = await userAPI.getUserWalletHistory(userDetails._id, nextPage, 20, walletFilter);

            if (response.success && response.data) {
                setWalletHistory(prev => [...prev, ...(response.data.transactions || [])]);
                setHasMoreWalletHistory(response.data.pagination?.hasNext || false);
                setWalletHistoryPage(nextPage);
            }
        } catch (error) {
            toast.error('Failed to load more wallet history');
            console.error('Error loading more wallet history:', error);
        } finally {
            setLoadingMoreWalletHistory(false);
        }
    };

    const handleWalletHistoryModalClose = () => {
        setShowWalletHistoryModal(false);
        setWalletHistory([]);
        setWalletHistoryPage(1);
        setHasMoreWalletHistory(true);
        setWalletFilter('all');
    };

    const handleWalletFilterChange = async (filter) => {
        if (filter === walletFilter) return;
        setWalletFilter(filter);
        setWalletHistoryPage(1);

        try {
            setWalletHistoryLoading(true);
            const response = await userAPI.getUserWalletHistory(userDetails._id, 1, 20, filter);

            if (response.success && response.data) {
                setWalletHistory(response.data.transactions || []);
                setHasMoreWalletHistory(response.data.pagination?.hasNext || false);
            }
        } catch (error) {
            toast.error('Failed to filter wallet history');
            console.error('Error filtering wallet history:', error);
        } finally {
            setWalletHistoryLoading(false);
        }
    };

    const handleViewCoupons = async (filter = 'active') => {
        try {
            setCouponsLoading(true);
            setCouponsFilter(filter);
            const response = await userAPI.getUserCoupons(userDetails._id, filter);

            if (response.success && response.data) {
                setCoupons(response.data || []);
                setShowCouponsModal(true);
            } else {
                toast.error(response.msg || 'Failed to fetch coupons');
            }
        } catch (error) {
            toast.error('Failed to fetch coupons');
            console.error('Error fetching coupons:', error);
        } finally {
            setCouponsLoading(false);
        }
    };

    const handleCouponsModalClose = () => {
        setShowCouponsModal(false);
        setCoupons([]);
        setCouponsFilter('active');
    };

    const handleCouponsFilterChange = async (filter) => {
        if (filter === couponsFilter) return;
        setCouponsFilter(filter);

        try {
            setCouponsLoading(true);
            const response = await userAPI.getUserCoupons(userDetails._id, filter);

            if (response.success && response.data) {
                setCoupons(response.data || []);
            }
        } catch (error) {
            toast.error('Failed to filter coupons');
            console.error('Error filtering coupons:', error);
        } finally {
            setCouponsLoading(false);
        }
    };

    const getAvatarColor = (name = "") => {
        const colors = [
            "#f87171", // red
            "#60a5fa", // blue
            "#34d399", // green
            "#fbbf24", // yellow
            "#a78bfa", // purple
            "#fb923c", // orange
            "#38bdf8", // sky
            "#f472b6", // pink
        ];

        let hash = 0;

        for (let i = 0; i < name.length; i++) {
            hash = name.charCodeAt(i) + ((hash << 5) - hash);
        }

        const index = Math.abs(hash % colors.length);

        return colors[index];
    }

    return (
        <>
        <div className={`users-page ${isModal ? 'is-modal' : ''}`}>
            {!isModal && (
                <div className="users-page-header">
                    <div className="users-page-title">
                        <h1>User Management</h1>
                        <p>Manage and view user information</p>
                    </div>
                </div>
            )}

            {!isModal && (
                <div className="users-find-section">
                    <div className="users-find-header">
                        <h2>Find User</h2>
                        <button className="users-find-button" onClick={() => setShowModal(true)}>
                            <Search size={18} />
                            Find a User
                        </button>
                    </div>
                </div>
            )}

            {!isModal && (
                <>
                    {statsError ? (
                        <div className="users-error-state">
                            <p>{statsError}</p>
                            <button onClick={fetchUserStats} className="users-retry-button">
                                <RefreshCw size={16} />
                                Retry
                            </button>
                        </div>
                    ) : (
                        <div className="users-stats-grid">
                            <div className="users-stat-card">
                                <div className="users-stat-icon-circle blue">
                                    <UsersIcon size={20} />
                                </div>
                                <div className="users-stat-content">
                                    <div className="users-stat-label">Total Users</div>
                                    <div className="users-stat-value">
                                        {statsLoading ? '-' : userStats.totalUsers}
                                    </div>
                                </div>
                            </div>

                            <div className="users-stat-card">
                                <div className="users-stat-icon-circle green">
                                    <Calendar size={20} />
                                </div>
                                <div className="users-stat-content">
                                    <div className="users-stat-label">Joined Today</div>
                                    <div className="users-stat-value">
                                        {statsLoading ? '-' : userStats.joinedToday}
                                    </div>
                                    {!statsLoading && (
                                        <div className="users-stat-subtext">
                                            <span>Registered: {userStats.joinedTodayRegistered}</span>
                                            <span>Guest: {userStats.joinedTodayGuest}</span>
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div className="users-stat-card">
                                <div className="users-stat-icon-circle purple">
                                    <CalendarClock size={20} />
                                </div>
                                <div className="users-stat-content">
                                    <div className="users-stat-label">Last 7 Days</div>
                                    <div className="users-stat-value">
                                        {statsLoading ? '-' : userStats.last7Days}
                                    </div>
                                </div>
                            </div>

                            <div className="users-stat-card">
                                <div className="users-stat-icon-circle orange">
                                    <CalendarCheckIcon size={20} />
                                </div>
                                <div className="users-stat-content">
                                    <div className="users-stat-label">Last 30 Days</div>
                                    <div className="users-stat-value">
                                        {statsLoading ? '-' : userStats.last30Days}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {!statsError && (
                    <div className="users-nationality-section">
                        <div className="users-nationality-header">
                            <div>
                                <h2>Nationality & Language</h2>
                                <p>Language breakdown is available for India</p>
                            </div>
                        </div>

                        <div className="users-nationality-summary">
                            <div className="users-stat-card users-nationality-summary-card">
                                <div className="users-stat-icon-circle teal">
                                    <Globe size={20} />
                                </div>
                                <div className="users-stat-content">
                                    <div className="users-stat-label">Total Nationalities</div>
                                    <div className="users-stat-value">
                                        {statsLoading ? '-' : userStats.totalNationalities}
                                    </div>
                                </div>
                            </div>
                            <div className="users-stat-card users-nationality-summary-card">
                                <div className="users-stat-icon-circle blue">
                                    <UsersIcon size={20} />
                                </div>
                                <div className="users-stat-content">
                                    <div className="users-stat-label">With Nationality</div>
                                    <div className="users-stat-value">
                                        {statsLoading ? '-' : userStats.usersWithNationality}
                                    </div>
                                </div>
                            </div>
                            <div className="users-stat-card users-nationality-summary-card">
                                <div className="users-stat-icon-circle orange">
                                    <UsersIcon size={20} />
                                </div>
                                <div className="users-stat-content">
                                    <div className="users-stat-label">Not Set</div>
                                    <div className="users-stat-value">
                                        {statsLoading ? '-' : userStats.usersWithoutNationality}
                                    </div>
                                </div>
                            </div>
                        </div>

                        {statsLoading ? (
                            <div className="users-nationality-empty">Loading nationality stats…</div>
                        ) : userStats.nationalities.length === 0 ? (
                            <div className="users-nationality-empty">No nationality data available</div>
                        ) : (
                            <>
                                <div className="users-nationality-list">
                                    {userStats.nationalities.map((item) => (
                                        <div
                                            key={item.country}
                                            className="users-nationality-chip"
                                        >
                                            <span className="users-nationality-chip-name">
                                                {getCountryName(item.country)}
                                            </span>
                                            <span className="users-nationality-chip-count">
                                                {item.count}
                                            </span>
                                        </div>
                                    ))}
                                </div>

                                {(() => {
                                    const indiaStats = userStats.nationalities.find(
                                        (n) => n.country === 'india'
                                    );
                                    if (!indiaStats) return null;
                                    const languages = (Array.isArray(indiaStats.languages)
                                        ? indiaStats.languages
                                        : []
                                    ).filter((lang) => (lang.language || '').trim());
                                    return (
                                        <div className="users-language-panel">
                                            <div className="users-language-panel-header">
                                                <h3>
                                                    Languages · {getCountryName(indiaStats.country)}
                                                </h3>
                                                <span>{indiaStats.count} users</span>
                                            </div>
                                            {languages.length === 0 ? (
                                                <div className="users-nationality-empty">
                                                    No language data for India
                                                </div>
                                            ) : (
                                                <div className="users-language-list">
                                                    {languages.map((lang) => (
                                                        <div
                                                            key={`india-${lang.language}`}
                                                            className="users-language-row"
                                                        >
                                                            <span className="users-language-name">
                                                                {getLanguageName(lang.language)}
                                                            </span>
                                                            <div className="users-language-bar-track">
                                                                <div
                                                                    className="users-language-bar-fill"
                                                                    style={{
                                                                        width: `${Math.max(
                                                                            4,
                                                                            Math.round(
                                                                                (lang.count / indiaStats.count) * 100
                                                                            )
                                                                        )}%`,
                                                                    }}
                                                                />
                                                            </div>
                                                            <span className="users-language-count">
                                                                {lang.count}
                                                            </span>
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    );
                                })()}
                            </>
                        )}
                    </div>
                    )}
                </>
            )}

            {searchError && isModal ? (
                <div className="users-error-state">
                    <p>{searchError}</p>
                    <button onClick={() => handleSearch(searchType, searchValue, true)} className="users-retry-button">
                        <RefreshCw size={16} />
                        Retry
                    </button>
                </div>
            ) : searchLoading && isModal ? (
                <div className="users-loading-state">
                    <div className="users-loading-spinner"></div>
                    <p>Searching user details...</p>
                </div>
            ) : ((!isModal && showDetailsModal) || (userDetails && isModal)) ? (
                <UserDetailsShell isModal={isModal} onClose={handleDetailsModalClose}>
                {searchLoading ? (
                    <div className="users-loading-state">
                        <div className="users-loading-spinner"></div>
                        <p>Searching user details...</p>
                    </div>
                ) : searchError && !userDetails ? (
                    <div className="users-error-state">
                        <p>{searchError}</p>
                        <button onClick={() => handleSearch(searchType, searchValue, true)} className="users-retry-button">
                            <RefreshCw size={16} />
                            Retry
                        </button>
                    </div>
                ) : userDetails ? (
                <div className={`users-results ${!isModal ? 'in-details-modal' : ''}`}>
                    {userDetails.isDeleted && (
                        <div className="users-deleted-banner" role="alert">
                            This account has been deleted by the user
                        </div>
                    )}
                    <div className="users-details-card">
                        <div className="users-profile-section">
                            <div className="users-profile-image-container">
                                {userDetails.profilePicture ? (
                                    <img src={userDetails.profilePicture} alt="Profile" className="users-profile-image" />
                                ) : (
                                    <div
                                        className="users-profile-initials"
                                        style={{ backgroundColor: getAvatarColor(userDetails._id) }}
                                    >
                                        {getInitialsFromUser(userDetails)}
                                    </div>
                                )}
                            </div>
                            <div className="users-details-header-content">
                                <div className="users-header-row" style={{ marginBottom: 0 }}>
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                                        <h3 style={{ margin: 0 }}>User Details</h3>
                                    </div>
                                    <div className="users-header-actions">
                                        <button className="users-action-logs-button" onClick={handleViewActionLogs} disabled={actionLogsLoading}>
                                            {actionLogsLoading ? 'Loading...' : 'Action Logs'}
                                        </button>
                                        <button className="users-action-logs-button users-coin-history-button" onClick={() => handleViewCoinHistory('all')} disabled={coinHistoryLoading}>
                                            {coinHistoryLoading ? 'Loading...' : 'Coin History'}
                                        </button>
                                        <button className="users-action-logs-button users-wallet-history-button" onClick={() => handleViewWalletHistory('all')} disabled={walletHistoryLoading}>
                                            {walletHistoryLoading ? 'Loading...' : 'Wallet History'}
                                        </button>
                                        <button className="users-action-logs-button users-coupons-button" onClick={() => handleViewCoupons('active')} disabled={couponsLoading}>
                                            {couponsLoading ? 'Loading...' : 'Coupons'}
                                        </button>
                                        {canViewWhatsappChat && (
                                            <button
                                                className="users-action-logs-button"
                                                onClick={handleViewWhatsappChatHistory}
                                                disabled={whatsappHistoryLoading}
                                            >
                                                {whatsappHistoryLoading && showWhatsappHistoryModal ? 'Loading...' : 'Chat History'}
                                            </button>
                                        )}
                                        {canEditWhatsappChat && (
                                            <button
                                                className="users-action-logs-button"
                                                onClick={() => setShowWhatsappNewChatPanel(true)}
                                            >
                                                <Plus size={14} style={{ marginRight: 4 }} />
                                                New Chat
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="users-info-row">
                            <div className="users-info-field">
                                <div className="users-field-with-icon">
                                    <UsersIcon size={20} className="users-field-icon" />
                                    <div className="users-field-content">
                                        <label>Name</label>
                                        <div className="users-info-value">
                                            {userDetails.name || `${userDetails.firstName || ''} ${userDetails.lastName || ''}`.trim() || '-'}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="users-info-field">
                                <div className="users-field-with-icon">
                                    <Mail size={20} className="users-field-icon" />
                                    <div className="users-field-content">
                                        <label>Email</label>
                                        <div className="users-info-value">{userDetails.email || '-'}</div>
                                    </div>
                                </div>
                            </div>

                            <div className="users-info-field">
                                <div className="users-field-with-icon">
                                    <Phone size={20} className="users-field-icon" />
                                    <div className="users-field-content">
                                        <label>Phone</label>
                                        <div className="users-info-value">
                                            {userDetails.countryCode && userDetails.phoneNumber
                                                ? `${userDetails.countryCode} - ${userDetails.phoneNumber}`
                                                : userDetails.phoneNumber || '-'}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="users-info-field">
                                <div className="users-field-with-icon">
                                    <AppWindow size={20} className="users-field-icon" />
                                    <div className="users-field-content">
                                        <label>App Version</label>
                                        <div className="users-info-value">{userDetails.appVersion || '-'}</div>
                                    </div>
                                </div>
                            </div>

                            <div className="users-info-field">
                                <div className="users-field-with-icon">
                                    <Clock size={20} className="users-field-icon" />
                                    <div className="users-field-content">
                                        <label>Created On</label>
                                        <div className="users-info-value">{userDetails.createdAt || "-"}</div>
                                    </div>
                                </div>
                            </div>

                            <div className="users-info-field">
                                <div className="users-field-with-icon">
                                    <Clock size={20} className="users-field-icon" />
                                    <div className="users-field-content">
                                        <label>Last Active</label>
                                        <div className="users-info-value">{userDetails.lastActive}</div>
                                    </div>
                                </div>
                            </div>

                            <div className="users-info-field">
                                <div className="users-field-with-icon">
                                    <Coins size={20} className="users-field-icon users-coin-icon" />
                                    <div className="users-field-content">
                                        <label>Coin Balance</label>
                                        <div className="users-info-value">
                                            {coinBalance || 0}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="users-info-field">
                                <div className="users-field-with-icon">
                                    <Banknote size={20} className="users-field-icon users-wallet-icon" />
                                    <div className="users-field-content">
                                        <label>Wallet Balance</label>
                                        <div className="users-info-value">
                                            {formatWalletBalance(walletBalance, walletCurrency)}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {orderSummary && (
                        <div className="users-orders-summary-card">
                            <div className='users-header-row'>
                                <h3>Orders Summary</h3>
                                <button className="users-order-history-button" onClick={handleViewOrderHistory}>
                                    Order History
                                </button>
                            </div>
                            <div className="users-orders-grid">
                                <div className="users-order-stat-card total">
                                    <div className="users-order-stat-value">{orderSummary.totalOrders}</div>
                                    <div className="users-order-stat-label">Total Orders</div>
                                </div>
                                <div className="users-order-stat-card delivered">
                                    <div className="users-order-stat-value">{orderSummary.deliveredOrders}</div>
                                    <div className="users-order-stat-label">Delivered</div>
                                </div>
                                <div className="users-order-stat-card progress">
                                    <div className="users-order-stat-value">{orderSummary.inProgressOrders}</div>
                                    <div className="users-order-stat-label">In Progress</div>
                                </div>
                                <div className="users-order-stat-card cancelled">
                                    <div className="users-order-stat-value">{orderSummary.cancelledOrders}</div>
                                    <div className="users-order-stat-label">Cancelled</div>
                                </div>
                            </div>
                        </div>
                    )}

                    {addresses && addresses.length > 0 && (
                        <div className="users-addresses-card">
                            <h3>Addresses ({addresses.length})</h3>
                            <div className="users-addresses-grid">
                                {addresses
                                    .sort((a, b) => (b.isDefault ? 1 : 0) - (a.isDefault ? 1 : 0))
                                    .map((address, index) => (
                                        <div key={address._id || index} className={`users-address-item ${address.isDefault ? 'default' : ''}`}>
                                            <div className="users-address-icons">
                                                {address.isDefault && (
                                                    <div className="users-address-default-badge">
                                                        <CheckCircleIcon size={14} />
                                                    </div>
                                                )}

                                                {helpers.hasPermission(adminData, ADMIN_PERMISSIONS.UPDATE_CUSTOMER_ADDRESS) && (
                                                <button
                                                    className="users-address-edit-button"
                                                    onClick={() => handleEditClick(address)}
                                                    title="Edit Address"
                                                >
                                                    <Pencil size={14} />
                                                </button>
                                                )}
                                            </div>

                                            <div className="users-address-details">
                                                {address.houseNo && (
                                                    <div className="users-address-field">
                                                        <strong>House No:</strong> {address.houseNo}
                                                    </div>
                                                )}
                                                {address.apartment && (
                                                    <div className="users-address-field">
                                                        <strong>Apartment:</strong> {address.apartment}
                                                    </div>
                                                )}
                                                {address.zone && (
                                                    <div className="users-address-field">
                                                        <strong>Zone:</strong> {address.zone}
                                                    </div>
                                                )}
                                                {address.directionToReach && (
                                                    <div className="users-address-field">
                                                        <strong>Directions:</strong> {address.directionToReach}
                                                    </div>
                                                )}
                                                {address.lat && (
                                                    <div className="users-address-field">
                                                        <strong>Lat:</strong> {address.lat}
                                                    </div>
                                                )}
                                                {address.createdAt && (
                                                    <div className="users-address-field">
                                                        <strong>Created At:</strong> {address.createdAt}
                                                    </div>
                                                )}
                                                {(address.receiversPhoneNUmber || address.receiversPhoneNumber) && (
                                                    <div className="users-address-field">
                                                        <strong>Phone:</strong> {address.receiversPhoneNumber || address.receiversPhoneNUmber}
                                                    </div>
                                                )}
                                                {address.receiversWhatsappNumber && (
                                                    <div className="users-address-field">
                                                        <strong>WhatsApp:</strong> {address.whatsappCountryCode ? `${address.whatsappCountryCode} ` : ''}{address.receiversWhatsappNumber}
                                                    </div>
                                                )}
                                                {address.long && (
                                                    <div className="users-address-field users-address-row">
                                                        <span>
                                                            <strong>Long:</strong> {address.long}
                                                        </span>
                                                        <button
                                                            className="users-view-map-button"
                                                            onClick={() => openInMaps(address.lat, address.long)}
                                                        >
                                                            View in Map
                                        </button>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    ))}
                            </div>
                        </div>
                    )}

                    {devices && devices.length > 0 && (
                        <div className="users-devices-card">
                            <h3>Devices ({devices.length})</h3>
                            <div className="users-devices-grid">
                                {devices.map((device, index) => {
                                        const isWeb = String(device.platform || '').toLowerCase().includes('web');
                                        const rawPlatform = device.platform || (isWeb ? 'web' : 'mobile');
                                        const platformName = rawPlatform.charAt(0).toUpperCase() + rawPlatform.slice(1).toLowerCase();
                                        
                                        return (
                                            <div key={device._id || index} className="users-device-item">
                                                <div className="users-device-details">
                                                    <div className="users-device-field">
                                                        <strong>Platform:</strong> {platformName}
                                                    </div>
                                                    {isWeb ? (
                                                        <>
                                                            {device.webDetails?.webBrowser && (
                                                                <div className="users-device-field">
                                                                    <strong>Web Browser:</strong> {device.webDetails.webBrowser}
                                                                </div>
                                                            )}
                                                            {device.webDetails?.webVersion && (
                                                                <div className="users-device-field">
                                                                    <strong>Browser Version:</strong> {device.webDetails.webVersion}
                                                                </div>
                                                            )}
                                                            {device.lastActive && (
                                                                <div className="users-device-field">
                                                                    <strong>Last Active:</strong> {device.lastActive}
                                                                </div>
                                                            )}
                                                            {device.deviceId && (
                                                                <div className="users-device-field">
                                                                    <strong>Device ID:</strong> <span className="code-font">{device.deviceId}</span>
                                                                </div>
                                                            )}
                                                        </>
                                                    ) : (
                                                        <>
                                                            {device.appDetails?.model && (
                                                                <div className="users-device-field">
                                                                    <strong>Model:</strong> {device.appDetails.model}
                                                                </div>
                                                            )}
                                                            {device.appDetails?.osVersion && (
                                                                <div className="users-device-field">
                                                                    <strong>OS Version:</strong> {device.appDetails.osVersion}
                                                                </div>
                                                            )}
                                                            {device.appDetails?.appVersion && (
                                                                <div className="users-device-field">
                                                                    <strong>App Version:</strong> v{device.appDetails.appVersion}
                                                                </div>
                                                            )}
                                                            {device.lastActive && (
                                                                <div className="users-device-field">
                                                                    <strong>Last Active:</strong> {device.lastActive}
                                                                </div>
                                                            )}
                                                            {device.deviceId && (
                                                                <div className="users-device-field">
                                                                    <strong>Device ID:</strong> <span className="code-font">{device.deviceId}</span>
                                                                </div>
                                                            )}
                                                        </>
                                                    )}
                                                    {/* {device._id && (
                                                        <div className="users-device-field">
                                                            <strong>ID:</strong> <span className="code-font">{device._id}</span>
                                                        </div>
                                                    )} */}
                                                </div>
                                            </div>
                                        );
                                    })}
                            </div>
                        </div>
                    )}
                </div>
                ) : null}
                </UserDetailsShell>
            ) : null}

            {showModal && (
                <div className="users-modal-overlay">
                    <div className="users-modal-content" onClick={(e) => e.stopPropagation()}>
                        <h2 className="users-modal-header">Find User</h2>

                        <div className="users-form-group">
                            <label className="users-form-label">Search Type</label>
                            <select
                                className="users-form-select"
                                value={searchType}
                                onChange={(e) => setSearchType(e.target.value)}
                            >
                                <option value="phone">Phone</option>
                                <option value="email">Email</option>
                            </select>
                        </div>

                        <div className="users-form-group">
                            <label className="users-form-label">
                                {searchType === 'email' ? 'Email' : 'Phone'}
                            </label>

                            <div className="users-phone-input-wrapper">
                                {searchType === "phone" && (
                                    <span className="users-phone-country-code">+974</span>
                                )}

                                <input
                                    type={searchType === 'email' ? 'email' : 'tel'}
                                    className={`users-form-input ${searchType === "phone" ? "with-code" : ""}`}
                                    placeholder={
                                        searchType === 'email' ? 'Enter email address' : 'Enter phone number'
                                    }
                                    value={searchValue}
                                    onChange={(e) => setSearchValue(e.target.value)}
                                />
                            </div>
                        </div>

                        <div className="users-modal-actions">
                            <button
                                className="users-modal-button secondary"
                                onClick={handleModalClose}
                                disabled={searchLoading}
                            >
                                Cancel
                            </button>
                            <button
                                className="users-modal-button primary"
                                onClick={() => handleSearch()}
                                disabled={searchLoading}
                            >
                                {searchLoading ? 'Searching...' : 'Search'}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* ---- Confirm Modal commented out ----
            {showConfirmModal && (
                <div className="users-modal-overlay">
                    <div className="users-modal-content" onClick={(e) => e.stopPropagation()}>
                        <h2 className="users-modal-header">Confirm Edit</h2>
                        <div className="users-confirm-modal-body">
                            <p>To edit the address, an OTP will be sent to the user's registered phone number.</p>
                            <p className="users-confirm-warning">Do you want to continue?</p>
                        </div>
                        <div className="users-modal-actions">
                            <button className="users-modal-button secondary" onClick={() => setShowConfirmModal(false)}>No</button>
                            <button className="users-modal-button primary" onClick={handleConfirmEdit} disabled={sendOtpLoading}>
                                {sendOtpLoading ? "Sending OTP..." : "Yes, Send OTP"}
                            </button>
                        </div>
                    </div>
                </div>
            )}
            ---- end Confirm Modal ---- */}

            {/* ---- OTP Modal commented out ----
            {showOtpModal && (
                <div className="users-modal-overlay">
                    <div className="users-modal-content" onClick={(e) => e.stopPropagation()}>
                        <h2 className="users-modal-header">Verify OTP</h2>
                        <div className="users-otp-modal-body">
                            <div className="users-form-group" style={{ padding: 0 }}>
                                <label className="users-form-label">OTP</label>
                                <input type="text" className="users-form-input" placeholder="Enter otp" value={otpValue} onChange={(e) => { setOtpValue(e.target.value); }} maxLength="4" />
                            </div>
                        </div>
                        <div className="users-modal-actions">
                            <button className="users-modal-button secondary" onClick={handleOtpModalClose}>Cancel</button>
                            <button className="users-modal-button primary" onClick={handleOtpSubmit} disabled={!otpValue || verifyOtpLoading}>
                                {verifyOtpLoading ? "Verifying..." : "Verify"}
                            </button>
                        </div>
                    </div>
                </div>
            )}
            ---- end OTP Modal ---- */}

            {showEditModal && (
                <div className="users-modal-overlay">
                    <div className="users-modal-content edit-modal-large" onClick={(e) => e.stopPropagation()}>
                        <h2 className="users-modal-header">Edit Address</h2>

                        <div className="users-edit-modal-body">
                            <div className="users-form-group" style={{ padding: 0 }}>
                                <label className="users-form-label">House No</label>
                                <input
                                    type="text"
                                    className="users-form-input"
                                    placeholder="Enter house number"
                                    value={editFormData.houseNo}
                                    onChange={(e) => handleEditFormChange('houseNo', e.target.value)}
                                />
                            </div>

                            <div className="users-form-group" style={{ padding: 0 }}>
                                <label className="users-form-label">Apartment</label>
                                <input
                                    type="text"
                                    className="users-form-input"
                                    placeholder="Enter apartment name"
                                    value={editFormData.apartment}
                                    onChange={(e) => handleEditFormChange('apartment', e.target.value)}
                                />
                            </div>

                            <div className="users-form-group" style={{ padding: 0 }}>
                                <label className="users-form-label">Zone</label>
                                <input
                                    type="text"
                                    className="users-form-input"
                                    placeholder="Enter zone"
                                    value={editFormData.zone}
                                    onChange={(e) => handleEditFormChange('zone', e.target.value)}
                                />
                            </div>

                            <div className="users-form-group" style={{ padding: 0 }}>
                                <label className="users-form-label">Directions to Reach</label>
                                <textarea
                                    className="users-form-input"
                                    placeholder="Enter directions"
                                    value={editFormData.directionToReach}
                                    onChange={(e) => handleEditFormChange('directionToReach', e.target.value)}
                                    rows="3"
                                    style={{ resize: 'vertical' }}
                                />
                            </div>

                            <div className="users-form-group" style={{ padding: 0 }}>
                                <label className="users-form-label">Map Link or Coordinates</label>
                                <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                                    <button
                                        type="button"
                                        className="users-edit-addr-pick-btn-unique"
                                        onClick={() => setShowMapPicker(true)}
                                    >
                                        <MapPin size={14} /> Pick Location
                                    </button>
                                    <input
                                        type="text"
                                        className="users-edit-addr-maplink-input-unique"
                                        placeholder="Or paste Google Maps link here..."
                                        value={editFormData.mapLink}
                                        onChange={handleMapLinkChange}
                                    />
                                </div>
                                {(() => {
                                    const status = getMapLinkCoordStatus();
                                    if (!status) return null;
                                    if (status.info) {
                                        return (
                                            <div className="custom-order-coords-below" style={{ marginTop: '8px', padding: '8px 12px', borderRadius: '6px', border: '1px solid #bfdbfe', backgroundColor: '#eff6ff', color: '#1d4ed8', display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px' }}>
                                                <div style={{ width: '14px', height: '14px', border: '2px solid #3b82f6', borderTopColor: 'transparent', borderRadius: '50%', animation: 'spin 1s linear infinite', flexShrink: 0 }}></div>
                                                <span>{status.message}</span>
                                            </div>
                                        );
                                    }
                                    if (status.success) {
                                        return (
                                            <div className="custom-order-coords-below" style={{ marginTop: '8px', padding: '8px 12px', borderRadius: '6px', border: '1px solid #bbf7d0', backgroundColor: '#f0fdf4', color: '#15803d', display: 'flex', alignItems: 'center', gap: '6px', fontSize: '13px' }}>
                                                <span style={{ color: '#16a34a', fontWeight: 'bold' }}>✓</span>
                                                <span>Coordinates fetched successfully: {status.lat?.toFixed(6)}, {status.lng?.toFixed(6)}</span>
                                            </div>
                                        );
                                    }
                                    if (status.warning) {
                                        return (
                                            <div className="custom-order-coords-below" style={{ marginTop: '8px', padding: '8px 12px', borderRadius: '6px', border: '1px solid #fde68a', backgroundColor: '#fffbeb', color: '#b45309', display: 'flex', alignItems: 'center', gap: '6px', fontSize: '13px' }}>
                                                <span style={{ color: '#d97706', fontWeight: 'bold' }}>⚠</span>
                                                <span>{status.message}</span>
                                            </div>
                                        );
                                    }
                                    return null;
                                })()}
                            </div>

                            <div className="users-form-group" style={{ padding: 0 }}>
                                <label className="users-form-label">Receiver Name</label>
                                <input
                                    type="text"
                                    className="users-form-input"
                                    placeholder="Enter name"
                                    value={editFormData.receiversName}
                                    onChange={(e) => handleEditFormChange('receiversName', e.target.value)}
                                />
                            </div>

                            <div className="users-form-group" style={{ padding: 0 }}>
                                <label className="users-form-label">Receiver Phone Number</label>
                                <div className="users-edit-addr-input-group">
                                    <span className="users-edit-addr-prefix">+974</span>
                                    <input
                                        type="text"
                                        className="users-edit-addr-input"
                                        placeholder="Enter phone number"
                                        value={editFormData.receiversPhoneNumber}
                                        onChange={(e) => handleEditFormChange('receiversPhoneNumber', e.target.value.replace(/[^0-9]/g, ''))}
                                        maxLength="8"
                                    />
                                </div>
                            </div>

                            <div className="users-form-group" style={{ padding: 0 }}>
                                <label className="users-form-label">Receiver WhatsApp Number</label>
                                <div className="users-edit-addr-input-group">
                                    <input
                                        type="text"
                                        className="users-edit-addr-prefix-input"
                                        value={editFormData.whatsappCountryCode}
                                        onChange={(e) => handleEditFormChange('whatsappCountryCode', e.target.value)}
                                        placeholder="+974"
                                    />
                                    <input
                                        type="text"
                                        className="users-edit-addr-input"
                                        placeholder="Enter WhatsApp number"
                                        value={editFormData.receiversWhatsappNumber}
                                        onChange={(e) => handleEditFormChange('receiversWhatsappNumber', e.target.value.replace(/[^0-9]/g, ''))}
                                        maxLength="15"
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="users-modal-actions">
                            <button
                                className="users-modal-button secondary"
                                onClick={handleEditModalClose}
                            >
                                Cancel
                            </button>
                            <button
                                className="users-modal-button primary"
                                onClick={handleEditSubmit}
                                disabled={updateAddressLoading}
                            >
                                {updateAddressLoading ? "Updating..." : "Update Address"}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {showActionLogsModal && (
                <div className="users-modal-overlay" onClick={handleActionLogsModalClose}>
                    <div className="users-modal-content users-timeline-modal" onClick={(e) => e.stopPropagation()}>
                        <div className="users-timeline-modal-header">
                            <h2 className="users-timeline-modal-title">Action Logs Timeline</h2>
                            <div className="users-timeline-header-actions">
                                <button
                                    className="users-timeline-refresh-button"
                                    onClick={handleRefreshLogs}
                                    disabled={refreshingLogs}
                                    title="Refresh"
                                >
                                    <RefreshCw size={18} className={refreshingLogs ? 'spinning' : ''} />
                                </button>
                                <button className="users-timeline-close-button" onClick={handleActionLogsModalClose}>
                                    <X size={20} />
                                </button>
                            </div>
                        </div>

                        <div className="users-timeline-container">
                            {actionLogs.length === 0 ? (
                                <div className="users-timeline-empty">
                                    <p>No action logs found</p>
                                </div>
                            ) : (
                                <div className="users-timeline-items-wrapper">
                                    {actionLogs.map((log, index) => (
                                        <div key={log._id} className="users-timeline-item">
                                            <div className="users-timeline-time">{log.relativeTime || ''}</div>
                                            <div className="users-timeline-dot-wrapper">
                                                <div className={`users-timeline-dot ${getTimelineDotColorByType(log.type)}`}></div>
                                                {index < actionLogs.length - 1 && (
                                                    <div className="users-timeline-line"></div>
                                                )}
                                            </div>
                                            <div className="users-timeline-content">
                                                <div className="users-timeline-title-wrapper">
                                                    <div className="users-timeline-title-with-badge">
                                                        <div className="users-timeline-title">
                                                            {log.type ? log.type.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase()) : ''}
                                                        </div>
                                                        {log.count && log.count > 1 && (
                                                            <span className="users-timeline-count-badge">{log.count}</span>
                                                        )}
                                                    </div>
                                                    {log.attributes && Array.isArray(log.attributes) && log.attributes.filter(Boolean).length > 0 && (
                                                        <div className="users-timeline-attributes">
                                                            {log.attributes.map((attr, attrIndex) => (
                                                                <span key={attrIndex} className="users-timeline-attribute-tag">
                                                                    {formatAttributeName(attr)}
                                                                </span>
                                                            ))}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                    {hasMoreLogs && (
                                        <div className="users-load-more-container">
                                            <button
                                                className="users-load-more-button"
                                                onClick={handleLoadMoreLogs}
                                                disabled={loadingMoreLogs}
                                            >
                                                {loadingMoreLogs ? 'Loading...' : 'Load More'}
                                            </button>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}

            {showCoinHistoryModal && (
                <div className="users-modal-overlay" onClick={handleCoinHistoryModalClose}>
                    <div className="users-modal-content users-coin-history-modal" onClick={(e) => e.stopPropagation()}>
                        <div className="users-coin-history-modal-header">
                            <div className="users-coin-history-header-left">
                                <h2 className="users-coin-history-modal-title">Coin History</h2>
                            </div>
                            <button className="users-timeline-close-button" onClick={handleCoinHistoryModalClose}>
                                <X size={20} />
                            </button>
                        </div>

                        <div className="users-coin-filter-badges">
                            <button
                                className={`users-coin-filter-badge ${coinFilter === 'all' ? 'active' : ''}`}
                                onClick={() => handleCoinFilterChange('all')}
                            >
                                All
                            </button>
                            <button
                                className={`users-coin-filter-badge earned ${coinFilter === 'earned' ? 'active' : ''}`}
                                onClick={() => handleCoinFilterChange('earned')}
                            >
                                Earned
                            </button>
                            <button
                                className={`users-coin-filter-badge redeemed ${coinFilter === 'redeemed' ? 'active' : ''}`}
                                onClick={() => handleCoinFilterChange('redeemed')}
                            >
                                Redeemed
                            </button>
                        </div>

                        <div className="users-coin-history-container">
                            {coinHistoryLoading ? (
                                <div className="users-coin-history-loading">
                                    <p>Loading...</p>
                                </div>
                            ) : coinHistory.length === 0 ? (
                                <div className="users-coin-history-empty">
                                    <p>No coin transactions found</p>
                                </div>
                            ) : (
                                <div className="users-coin-history-items-wrapper">
                                    {coinHistory.map((monthGroup, groupIndex) => (
                                        <div key={groupIndex} className="users-coin-history-month-group">
                                            <div className="users-coin-history-month-label">{monthGroup.month}</div>
                                            {monthGroup.list && monthGroup.list.map((transaction, transIndex) => (
                                                <div key={transIndex} className={`users-coin-history-item ${transaction.type}`}>
                                                    <div className="users-coin-history-item-left">
                                                        <div className="users-coin-history-date">{transaction.date}</div>
                                                        <div className="users-coin-history-expiry">{transaction.expiryOn}</div>
                                                    </div>
                                                    <div className={`users-coin-history-amount ${transaction.type}`}>
                                                        {transaction.amount}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    ))}
                                    {hasMoreCoinHistory && (
                                        <div className="users-load-more-container">
                                            <button
                                                className="users-load-more-button"
                                                onClick={handleLoadMoreCoinHistory}
                                                disabled={loadingMoreCoinHistory}
                                            >
                                                {loadingMoreCoinHistory ? 'Loading...' : 'Load More'}
                                            </button>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}

            {showWalletHistoryModal && (
                <div className="users-modal-overlay" onClick={handleWalletHistoryModalClose}>
                    <div className="users-modal-content users-wallet-history-modal" onClick={(e) => e.stopPropagation()}>
                        <div className="users-wallet-history-modal-header">
                            <div className="users-wallet-history-header-left">
                                <h2 className="users-wallet-history-modal-title">Wallet History</h2>
                                <span className="users-wallet-balance-badge">
                                    <Banknote size={16} />
                                    {formatWalletBalance(walletBalance, walletCurrency)}
                                </span>
                            </div>
                            <button className="users-timeline-close-button" onClick={handleWalletHistoryModalClose}>
                                <X size={20} />
                            </button>
                        </div>

                        <div className="users-wallet-filter-badges">
                            <button
                                className={`users-wallet-filter-badge ${walletFilter === 'all' ? 'active' : ''}`}
                                onClick={() => handleWalletFilterChange('all')}
                            >
                                All
                            </button>
                            <button
                                className={`users-wallet-filter-badge credited ${walletFilter === 'credited' ? 'active' : ''}`}
                                onClick={() => handleWalletFilterChange('credited')}
                            >
                                Credited
                            </button>
                            <button
                                className={`users-wallet-filter-badge debited ${walletFilter === 'debited' ? 'active' : ''}`}
                                onClick={() => handleWalletFilterChange('debited')}
                            >
                                Debited
                            </button>
                        </div>

                        <div className="users-wallet-history-container">
                            {walletHistoryLoading ? (
                                <div className="users-wallet-history-loading">
                                    <p>Loading...</p>
                                </div>
                            ) : walletHistory.length === 0 ? (
                                <div className="users-wallet-history-empty">
                                    <p>No wallet transactions found</p>
                                </div>
                            ) : (
                                <div className="users-wallet-history-items-wrapper">
                                    {walletHistory.map((monthGroup, groupIndex) => (
                                        <div key={groupIndex} className="users-wallet-history-month-group">
                                            <div className="users-wallet-history-month-label">{monthGroup.month}</div>
                                            {monthGroup.list && monthGroup.list.map((transaction, transIndex) => (
                                                <div key={transIndex} className={`users-wallet-history-item ${transaction.type}`}>
                                                    <div className="users-wallet-history-item-left">
                                                        <div className="users-wallet-history-date">{transaction.date}</div>
                                                        <div className="users-wallet-history-title">{transaction.title}</div>
                                                    </div>
                                                    <div className={`users-wallet-history-amount ${transaction.type}`}>
                                                        {transaction.amount} {transaction.currency || walletCurrency}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    ))}
                                    {hasMoreWalletHistory && (
                                        <div className="users-load-more-container">
                                            <button
                                                className="users-load-more-button"
                                                onClick={handleLoadMoreWalletHistory}
                                                disabled={loadingMoreWalletHistory}
                                            >
                                                {loadingMoreWalletHistory ? 'Loading...' : 'Load More'}
                                            </button>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}

            {showCouponsModal && (
                <div className="users-modal-overlay" onClick={handleCouponsModalClose}>
                    <div className="users-modal-content users-coupons-modal" onClick={(e) => e.stopPropagation()}>
                        <div className="users-coupons-modal-header">
                            <div className="users-coupons-header-left">
                                <h2 className="users-coupons-modal-title">User Coupons</h2>
                            </div>
                            <button className="users-timeline-close-button" onClick={handleCouponsModalClose}>
                                <X size={20} />
                            </button>
                        </div>

                        <div className="users-coupons-filter-badges">
                            <button
                                className={`users-coupon-filter-badge ${couponsFilter === 'active' ? 'active' : ''}`}
                                onClick={() => handleCouponsFilterChange('active')}
                            >
                                Active
                            </button>
                            <button
                                className={`users-coupon-filter-badge ${couponsFilter === 'inactive' ? 'active' : ''}`}
                                onClick={() => handleCouponsFilterChange('inactive')}
                            >
                                Inactive / Used
                            </button>
                        </div>

                        <div className="users-coupons-container">
                            {couponsLoading ? (
                                <div className="users-coupons-loading">
                                    <p>Loading...</p>
                                </div>
                            ) : coupons.length === 0 ? (
                                <div className="users-coupons-empty">
                                    <Ticket size={48} />
                                    <p>No {couponsFilter} coupons found</p>
                                </div>
                            ) : (
                                <div className="users-coupons-list">
                                    {coupons.map((coupon) => (
                                        <div key={coupon._id} className={`users-coupon-card ${couponsFilter === 'inactive' ? 'inactive' : ''}`}>
                                            <div className="users-coupon-card-header">
                                                <div className="users-coupon-code">{coupon.couponName}</div>
                                                {coupon.status && (
                                                    <span className={`users-coupon-status-badge ${coupon.status}`}>
                                                        {coupon.status === 'used' ? 'Used' : coupon.status === 'inactive' ? 'Inactive' : coupon.status === 'scheduled' ? 'Scheduled' : coupon.status === 'expired' ? "Expired" : ''}
                                                    </span>
                                                )}
                                            </div>
                                            <div className="users-coupon-card-body">
                                                <div className="users-coupon-main-info">
                                                    <span className="users-coupon-discount">
                                                        {coupon.discountType === 'percentage' || coupon.discountType === 'percentage_free_delivery'
                                                            ? `${coupon.percentageValue}%`
                                                            : coupon.discountType === 'free_delivery'
                                                                ? 'Free Delivery'
                                                                : '-'}
                                                    </span>
                                                    <span className="users-coupon-type">
                                                        {coupon.discountType === 'percentage_free_delivery' ? 'OFF + Free Del.' : coupon.discountType == 'percentage' ? "OFF" : ''}
                                                    </span>
                                                </div>

                                                <div className="users-coupon-meta-item">
                                                    <span className="users-meta-value">{coupon.minOrderAmount > 0 ? `Min Order QAR ${coupon.minOrderAmount}` : ''}</span>
                                                </div>
                                                <div className="users-coupon-meta-item">
                                                    <span className="users-meta-value">{coupon.validityText}</span>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </div>

            {showWhatsappHistoryModal && canViewWhatsappChat && userDetails && (
                <div className="users-modal-overlay" onClick={handleWhatsappHistoryModalClose}>
                    <div className="users-modal-content users-whatsapp-history-modal" onClick={(e) => e.stopPropagation()}>
                        <div className="users-whatsapp-history-modal-header">
                            <div className="users-whatsapp-history-modal-title-wrap">
                                <div className="wa-chat-avatar">
                                    {getUserDisplayName(userDetails).charAt(0).toUpperCase()}
                                </div>
                                <div>
                                    <h2 className="users-whatsapp-history-modal-title">
                                        Chat history of {getUserDisplayName(userDetails)}
                                    </h2>
                                    <p className="users-whatsapp-history-modal-phone">
                                        {normalizeWhatsappPhone(userDetails.countryCode, userDetails.phoneNumber)
                                            ? `+${normalizeWhatsappPhone(userDetails.countryCode, userDetails.phoneNumber)}`
                                            : 'No phone'}
                                    </p>
                                </div>
                            </div>
                            <div className="users-timeline-header-actions">
                                <button
                                    className="users-timeline-refresh-button"
                                    onClick={() => fetchWhatsappChatHistory(userDetails)}
                                    disabled={whatsappHistoryLoading}
                                    title="Refresh"
                                >
                                    <RefreshCw size={18} className={whatsappHistoryLoading ? 'spinning' : ''} />
                                </button>
                                <button className="users-timeline-close-button" onClick={handleWhatsappHistoryModalClose}>
                                    <X size={20} />
                                </button>
                            </div>
                        </div>

                        <div className="users-whatsapp-history-modal-chat">
                            <div className="wa-chat-detail-body wa-chat-thread-body users-whatsapp-history-thread">
                                {whatsappHistoryLoading && whatsappHistory.length === 0 ? (
                                    <div className="wa-chat-empty">Loading messages...</div>
                                ) : whatsappHistory.length === 0 ? (
                                    <div className="wa-chat-empty">No messages yet. Send the first message below.</div>
                                ) : (
                                    whatsappHistory.map((msg) => (
                                        <div
                                            key={`${msg.direction}-${msg._id}`}
                                            className={`wa-chat-bubble-row ${msg.direction === 'outgoing' ? 'outgoing' : 'incoming'}`}
                                        >
                                            <div className={`wa-chat-bubble ${msg.direction === 'outgoing' ? 'outgoing' : ''}`}>
                                                {msg.type === 'feedback' && <span className="wa-chat-type-badge feedback">Feedback</span>}
                                                <p className="wa-chat-bubble-text">{msg.text}</p>
                                                {Array.isArray(msg.selectedOptions) && msg.selectedOptions.length > 0 && (
                                                    <ul className="wa-chat-feedback-options">
                                                        {msg.selectedOptions.map((option) => (
                                                            <li key={option}>{option}</li>
                                                        ))}
                                                    </ul>
                                                )}
                                                <span className="wa-chat-bubble-time">
                                                    {msg.direction === 'outgoing' && msg.adminName ? `${msg.adminName} · ` : ''}
                                                    {formatWhatsappChatTime(msg.timestamp)}
                                                    {msg.direction === 'outgoing' && msg.status === 'failed' ? ' · Failed' : ''}
                                                </span>
                                            </div>
                                        </div>
                                    ))
                                )}
                                <div ref={whatsappMessagesEndRef} />
                            </div>

                            {canEditWhatsappChat ? (
                                <>
                                    {whatsappThreadMeta.canSendFreeForm === false && !whatsappHistoryLoading && (
                                        <div className="wa-chat-session-warning">
                                            {WHATSAPP_SESSION_BLOCKED_MSG}
                                        </div>
                                    )}
                                    <form className="wa-chat-composer" onSubmit={handleSendFromChatHistory}>
                                        <input
                                            type="text"
                                            value={whatsappComposerText}
                                            onChange={(e) => setWhatsappComposerText(e.target.value)}
                                            placeholder={whatsappThreadMeta.canSendFreeForm ? 'Type a message' : 'Reply window closed (24 hours)'}
                                            disabled={whatsappSending || !whatsappThreadMeta.canSendFreeForm}
                                        />
                                        <button type="submit" disabled={whatsappSending || !whatsappComposerText.trim() || !whatsappThreadMeta.canSendFreeForm} title="Send">
                                            <Send size={16} />
                                        </button>
                                    </form>
                                </>
                            ) : (
                                <div className="wa-chat-composer-disabled">You need edit permission to send messages.</div>
                            )}
                        </div>
                    </div>
                </div>
            )}

            {showWhatsappNewChatPanel && canEditWhatsappChat && userDetails && (
                <div className="users-whatsapp-side-panel-overlay" onClick={() => !whatsappSending && setShowWhatsappNewChatPanel(false)}>
                    <aside className="users-whatsapp-side-panel" onClick={(e) => e.stopPropagation()}>
                        <div className="users-whatsapp-side-panel-header">
                            <h2>New chat</h2>
                            <button type="button" onClick={() => setShowWhatsappNewChatPanel(false)} disabled={whatsappSending}>
                                <X size={18} />
                            </button>
                        </div>
                        <form className="users-whatsapp-side-panel-form" onSubmit={handleSendUserWhatsappMessage}>
                            <p className="users-whatsapp-side-panel-phone">
                                To: {normalizeWhatsappPhone(userDetails.countryCode, userDetails.phoneNumber) || 'No phone'}
                            </p>
                            <label>
                                Message
                                <textarea
                                    value={whatsappNewMessage}
                                    onChange={(e) => setWhatsappNewMessage(e.target.value)}
                                    placeholder="Type WhatsApp message"
                                    rows={6}
                                    required
                                />
                            </label>
                            <button type="submit" disabled={whatsappSending || !whatsappNewMessage.trim()}>
                                {whatsappSending ? 'Sending...' : (
                                    <>
                                        <Send size={14} /> Send message
                                    </>
                                )}
                            </button>
                        </form>
                    </aside>
                </div>
            )}

            <MapPickerModal
                isOpen={showMapPicker}
                onClose={() => setShowMapPicker(false)}
                initialCoords={mapPickerResolvedCoords ? [mapPickerResolvedCoords.lng, mapPickerResolvedCoords.lat] : null}
                onConfirm={handleMapPickerConfirm}
            />
        </>
    );
};

export default Users;
